var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-item",on:{"click":function($event){return _vm.$emit('add-to-cart',_vm.product)}}},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.product.name))]),_c('p',[_vm._v(_vm._s(_vm._f("numFormat")(_vm.product.price,'0,0.00'))+" "),_c('small',[_vm._v("บาท")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }